<template>
  <div class="privacyAgreement">
    <!-- <NavBar
      title="用户隐私权政策"
      left-arrow
      @click-left="back"
      id="nav_header"
      v-if="showNav"
    >
    </NavBar> -->
    <div class="navBar" v-if="showNav">
      <div class="arrow" @click="back()">〈</div>
      <div class="title" style="margin-right: 20px">用户隐私权政策</div>
    </div>

    <div class="agreement_content">
      <section>
        <div>
          <p class="textContent">
            <strong>贵州数字乡村平台用户隐私权政策</strong>
          </p>
          <p class="textContent">
            <a name="OLE_LINK2"></a
            ><a name="OLE_LINK1"
              >本版更新时间：2023年11月30日<br />本版生效时间：2023年12月5日</a
            >
          </p>
          <p class="textIndent">
            <a name="hint"></a><a name="preamble"></a><strong>导言</strong>
          </p>
          <p class="textIndent">
            【贵州小黑科技有限公司】（以下也称“我们”）深知个人信息对您的重要性，因此我们非常重视保护您的隐私和个人信息，我们亦将本《“贵州数字乡村平台”用户隐私权政策》（以下也称“本政策”）中的内容以高度审慎的义务对待和处理。本政策与您所使用的我们的产品与/或服务息息相关，您在下载、安装、启动、浏览、注册、登录、使用、卸载、退出我们的产品与/或服务（以下统称“使用我们的产品与/或服务”或“使用产品与/或服务”）时，我们将按照本政策的约定处理和保护您的个人信息，因此我们希望您能够仔细阅读、充分理解本政策的全文，并在需要时，按照本政策的指引，作出您认为适当的选择。本政策之中涉及的相关技术词汇，我们尽量以通俗易懂的表述向您解释，以便于您理解。
          </p>
          <p class="textIndent">
            <strong
              >您应当在仔细阅读、充分理解本《“贵州数字乡村平台”用户隐私权政策》后选择是否同意本政策的内容以及是否同意使用我们的产品与/或服务，如果您不同意本政策的内容，将可能导致我们的产品与/或服务无法正常运行，或者无法达到我们期待的服务效果，或者无法达到您期待的个人信息保护状态，对此，您应立即停止访问/使用我们的产品与/或服务。您使用或继续使用我们提供的产品与/或服务的行为，或者您在使用或继续使用我们提供的产品与/或服务的行为之前没有以任何明示的方式向我们表达异议，都表示您充分理解和同意本《“贵州数字乡村平台”用户隐私权政策》（包括更新版本）的全部内容。</strong
            >
          </p>
          <p class="textIndent">
            <strong
              >贵州小黑科技有限公司已经以字体加粗或其他合理方式提示您重点阅读本政策中与您的权益（可能）存在重大关系的条款，请您留意重点查阅。您应当在充分阅读、明确理解本政策前述加粗条款并同意本政策全部条款的有效性的前提下使用我们的产品与/或服务，您不会以我们未尽到合理提示义务为由而声称本政策中的条款非法或无效。</strong
            >
          </p>
          <p class="textIndent">
            如您在阅读本《“贵州数字乡村平台”用户隐私权政策》过程中有任何疑惑或其他相关事宜的，我们为您提供了多种反馈渠道，具体请见本政策“如何联系我们”章节，我们会尽快为您作出解答。
          </p>
          <p><a name="about"></a><strong>关于我们</strong></p>
          <p class="textIndent">
            贵州小黑科技有限公司是指包括贵州小黑科技有限公司及其关联公司在内的企业集团。
          </p>
          <div>
            <p>
              ●
              关联公司是指在现在、将来控制贵州小黑科技有限公司、受贵州小黑科技有限公司控制或与贵州小黑科技有限公司处于共同控制下的公司、机构。控制指通过所有权、有投票权的股份、合同、实际运营关联或其他被依法认定的方式直接或间接地拥有影响被控制对象管理/经营的能力。
            </p>
          </div>
          <div>
            <p>
              ●
              我们的主要运营公司基本情况如下：贵州小黑科技有限公司，成立于2017年12月22日，注册地址/常用办公地址：贵州省贵阳市高新区西部研发基地3号楼1单元6层1号；联系电话：0851-84727726；如您想更详细的了解我们的公司、平台，您可以通过本政策提供的联系方式与我们联系。
            </p>
          </div>
          <p class="textIndent">
            <strong
              >本《“贵州数字乡村平台”用户隐私权政策》将帮助您了解以下内容</strong
            >
          </p>
          <p>
            一、 本《”贵州数字乡村平台”用户隐私权政策》适用范围、相关词语涵义
          </p>
          <p>二、 我们如何收集和使用您的个人信息</p>
          <p>三、 我们如何使用Cookie和同类技术</p>
          <p>四、 我们如何共享、转让、公开披露您的个人信息</p>
          <p>五、 您对个人信息享有的控制权</p>
          <p>六、 我们如何存储和保护您的个人信息</p>
          <p>七、 本《”贵州数字乡村平台”用户隐私权政策》的更新</p>
          <p>八、 如何联系我们</p>
          <p>九、 其他</p>
          <p>
            <a name="Application"></a
            ><strong
              >一、本《“贵州数字乡村平台”用户隐私权政策》适用范围、相关词语涵义</strong
            >
          </p>
          <p>
            <strong
              >（一）本《“贵州数字乡村平台”用户隐私权政策》适用范围</strong
            >
          </p>
          <p>
            本《“贵州数字乡村平台”用户隐私权政策》适用于“贵州数字乡村平台”服务体系以网页平台、应用程序、小程序、公众号等向您提供的各项产品或服务，是所有产品与/或服务统一适用的通用内容。当您使用“贵州数字乡村平台”服务体系下的任何产品与/或服务时，本《“贵州数字乡村平台”用户隐私权政策》即适用，但如果该产品与/或服务单独设置了隐私条款/隐私协议的，单独的隐私条款/隐私协议优先适用；单独的隐私条款/隐私协议未提及的内容，适用本政策。
          </p>
          <p>
            但请您注意，本《“贵州数字乡村平台”用户隐私权政策》不适用于以下情况：
          </p>
          <p>
            1.为我们的产品与/或服务提供广告服务的第三方的信息收集/处理做法；
          </p>
          <p>
            2.我们的产品与/或服务可能会包含或链接至第三方提供的信息与/或第三方服务（包括任何第三方应用、网站、产品、服务等），这些信息与/或服务由第三方负责运营，您使用该信息与/或服务与我们无关。我们在此善意的提醒您，您在使用第三方信息与/或服务时，应留意和仔细阅读第三方向您展示的相关用户协议和隐私政策，并妥善保管和谨慎提供您的个人信息。本《“贵州数字乡村平台”用户隐私权政策》仅适用于我们所收集的您的个人信息，并不适用于任何第三方对您的个人信息的收集，以及任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方收集、储存和使用的您个人信息的行为在法律允许的范围内亦不承担任何责任；
          </p>
          <p>3.其他非“贵州数字乡村平台”服务体系向您提供的产品与/或服务内容。</p>
          <p>
            <strong>（二）相关词语涵义</strong>
          </p>
          <p>
            1.“贵州数字乡村平台”服务体系：包括但不限于我们提供的网站、应用程序（APP）、小程序、公众号包含的相关产品与/或服务功能。
          </p>
          <p>
            <strong
              >2.我们需要特别提醒您的是：由于我们的产品和服务较多，为您提供的产品和服务内容也有所不同，本《“贵州数字乡村平台”用户隐私权政策》为“贵州数字乡村平台”服务体系统一适用的一般性隐私条款，本政策约定的用户权利和我们提供的相关信息安全保护措施均适用于“贵州数字乡村平台”服务体系所有产品和服务；本政策所述之“贵州数字乡村平台”服务体系产品与/或服务以及我们收集的您个人信息的类型和对应的使用、处理规则等可能会因您使用的具体的产品/服务（包括客户端类型、软件版本等）而有所不同，具体以您实际使用的产品/服务的实际情况为准。针对我们的某些特定产品/服务，我们还将制定特定隐私条款或隐私协议，以便更具体地向您阐明我们的隐私规则和保护措施等内容。</strong
            >
          </p>
          <p>
            3.个人信息（出自于GB/T 35273-2020《信息安全技术
            个人信息安全规范》）：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。我们实际具体收集的个人信息种类以下文描述为准。
          </p>
          <p>
            <strong>4.个人敏感信息</strong>（出自于GB/T 35273-2020《信息安全技术
            个人信息安全规范》）：<strong>指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。</strong>我们实际具体收集的个人敏感信息种类以下文描述为准。<strong
              >相比其他个人信息，个人敏感信息可能对您的个人权益影响更大。我们在此善意的提醒您需在谨慎考虑后再向我们提供您的个人敏感信息。</strong
            >
          </p>
          <p>
            5.授权同意：是指您对您的个人信息进行特定处理做出明确授权的行为，包括通过积极的行为作出授权（即明示同意），也包括通过消极的不作为而作出授权。（出自于GB/T35273-2020
            《信息安全技术
            个人信息安全规范》）请您知悉，“授权同意”在本政策中有时亦表述为“授权”、“同意”。
          </p>
          <p>
            6.用户画像：通过收集、汇聚、分析个人信息，对您的个人特征，如职业、经济、教育、个人喜好、信用、行为等方面作出分析或预测，形成其个人特征模型的过程。（出自于B/T35273-2020
            《信息安全技术 个人信息安全规范》）
          </p>
          <p>
            匿名化：指通过对个人信息的技术处理，使得个人信息主体无法被识别或者被关联到，且处理后的信息不能被复原的过程。（出自于GB/T
            35273-2020《信息安全技术 个人信息安全规范》）
          </p>
          <p>
            7.去标识化：指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别或关联到个人信息主体的过程。（出自于GB/T
            35273-2020《信息安全技术 个人信息安全规范》）
          </p>
          <p>
            8.删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。（出自于GB/T
            35273-2020《信息安全技术 个人信息安全规范》）
          </p>
          <p>
            <a name="collect"></a
            ><strong>二、我们如何收集和使用您的个人信息</strong>
          </p>
          <p>
            您在使用我们的产品与/或服务时，我们需要/可能需要收集和使用您的一些个人信息，我们收集和使用的您的个人信息类型包括两种：<strong
              >第一种：我们产品与/或服务的核心业务功能所必需的信息：此类信息为产品与/或服务正常运行的必备信息，您须授权我们收集。如您拒绝提供，您将无法正常使用我们的产品与/或服务；第二种：我们产品与/或服务的附加业务功能可能需要收集的信息：此信息为非核心业务功能所需的信息，您可以选择是否授权我们收集。如您拒绝提供，将导致附加业务功能无法实现或无法达到我们拟达到的效果，但不影响您对核心业务功能的正常使用。</strong
            >
          </p>
          <p>
            <strong
              >我们需要特别提醒您的是：由于我们的产品和服务较多，为您提供的内容也不同，因此核心业务功能（包括其收集的您的个人信息类型）也会因产品/服务的内容不同而有所区别，具体以产品/服务实际提供为准。除此之外，您理解并同意，我们希望提供给您的产品和服务是完善的，所以我们会不断改进我们的产品和服务，包括技术，这意味着随着产品和服务的迭代、拓展、升级等，我们可能会经常推出新的业务功能或重新划分业务功能，并可能需要收集新的个人信息或变更个人信息使用目的或方式。如果某一需要收集您的个人信息的功能或产品/服务未能在本《“贵州数字乡村平台”用户隐私权政策》中予以说明的，我们会通过更新本政策、启动或浏览界面提示、弹窗、网站公告、站内信、发送邮件、短信等一种或多种方式另行向您说明该信息收集的目的、内容、使用方式和范围，并为您提供自主选择同意的方式，且在征得您同意后收集。</strong
            >在此过程中，如果您对相关事宜有任何疑惑的，可以通过文末提供的方式联系我们，我们会尽快为您作出解答。
          </p>
          <p>您需授权我们收集和使用您的个人信息的功能/场景包括：</p>
          <p>
            <strong>(一)账号注册/登录功能</strong>
          </p>
          <p>
            当您使用账号注册功能时，我们会收集由您主动提供给我们的一些单独或者结合识别您实名身份的信息，包括：<strong>手机号码、验证码匹配结果，</strong>并创建<strong>密码。</strong>&#xa0;<strong>您的密码将以加密形式进行自动存储、传输、验证，我们不会以明文方式存储、传输、验证您的密码。您在保管、输入、使用您的密码时，应当对物理环境、电子环境审慎评估，以防密码外泄。</strong>我们收集这些信息是用以完成注册程序、为您持续稳定提供专属于注册用户的产品与/或服务，并保护您的账号安全。<strong>您应知悉，手机号码和验证码匹配结果属于您的个人敏感信息，我们收集该类信息是为了满足相关法律法规的要求，如您拒绝提供可能导致您无法使用我们的此功能，请您谨慎考虑后再提供。</strong>同时，您也可以在注册时或后续使用过程中填写或补充<strong>您的昵称、头像、地址信息</strong>。
          </p>
          <p>
            需要说明的是，我们的一些产品支持您使用第三方平台的手机号（例如：微信）进行登录，如您使用第三方平台的账号登录的，我们将根据您的授权获取<strong
              >该第三方账号下的相关信息（包括：昵称、头像，具体以您的授权内容为准）以及身份验证信息（个人敏感信息）。</strong
            >
          </p>
          <p>
            我们收集这些信息是用于为您提供账号登录服务以及保障您的账号安全，防范安全风险。如您拒绝授权此类信息的，您将无法使用第三方平台的账号登录我们平台，但不影响我们为您提供的其他产品和服务的正常使用。
          </p>
          <p>
            <strong>(二)使用“贵州数字乡村平台”服务体系各项业务功能</strong>
          </p>
          <p>
            您在使用以下的“贵州数字乡村平台”服务体系下的产品与/或服务时，以产品或服务必备信息需求为限，我们可能会收集您使用的设备信息(包括操作系统、软件版本、语言设置、IP地址)，浏览信息(包括搜索关键词、访问页面链接和访问时间)，发表信息(包括文字、图片、视频)，位置信息，具体以各业务功能具体需求为准，<strong
              >收集此类信息是为了实现各项业务功能的前提，不会作为“贵州数字乡村平台”服务体系外的使用，如另做他用，我们会单独征求您的授权意向。</strong
            >
          </p>
          <p>
            在您使用“贵州数字乡村平台”服务体系下的产品与/或服务的过程中，我们会收集您在使用时主动提供或因为使用服务而产生的信息，用以向您提供服务、优化我们的服务以及保障您的帐号安全，拒绝提供某服务需要的信息仅会使您无法使用该部分服务，但不影响您正常使用“贵州数字乡村平台”服务体系的基本功能。
          </p>
          <p>
            <strong>数字化治理服务相关功能</strong>
          </p>
          <p>
            <strong>1.垃圾收运</strong>
          </p>
          <p>
            当您使用“贵州数字乡村平台”服务体系下的垃圾收运相关的设施设备管理、收运规划/查看、智能调度/预警、监控定位、数据统计/分析等服务或功能时，依据您需要服务的内容，我们需要您提供账号、姓名、联系电话、站点信息/照片、车辆信息/照片、定位等相关信息，以便能够为您提供相关服务。
          </p>
          <p>
            <strong>2.污水处理</strong>
          </p>
          <p>
            当您使用“贵州数字乡村平台”服务体系下的污水处理相关的基础设施管理、管网采集修正、远程监控、水质监测、智慧预警等服务或功能时，我们需要您提供账号、姓名、联系电话、站点信息/照片、监控信息、水质监测设备信息、定位等相关信息，以便能够为您提供相关服务。
          </p>
          <p>
            <strong>3.住房监管</strong>
          </p>
          <p>
            当您使用“贵州数字乡村平台”服务体系下的住房监管相关的农户/住房档案管理、巡查/勘验/督查、安全保障/预警、设计展示等服务或功能时，我们需要您提供账号、姓名、联系电话、房屋信息/照片、定位等相关信息，以便能够为您提供相关服务。
          </p>
          <p>
            <strong>4.人居环境治理</strong>
          </p>
          <p>
            当您使用“贵州数字乡村平台”服务体系下的人居环境治理相关的户厕采集/改造/管护、公厕采集/改造/管护、问题反馈、村庄清洁行动服务或等功能时，我们需要您提供账号、姓名、联系电话、问题照片、行动照片、定位等相关信息，以便能够为您提供相关服务。
          </p>
          <p>
            <strong>5.传统村落数字博物馆</strong>
          </p>
          <p>
            当您使用“贵州数字乡村平台”服务体系下的传统村落数字博物馆相关的村落建馆管理、村落信息管理、资源管理、农家民宿管理、村落素材管理等服务或功能时，我们需要您提供账号、姓名、联系电话、村落信息/照片/定位、民宿信息/照片、村落素材信息/照片等相关信息，以便能够为您提供相关服务。
          </p>
          <p>
            <strong>6.村级事务服务</strong>
          </p>
          <p>
            当您使用“贵州数字乡村平台”服务体系下的村级事务服务的村委管理、村民管理、意见反馈/处理、活动参与等服务或功能时，我们需要您提供账号、姓名、职务、联系电话、户主/家庭成员、照片/视频、定位等相关信息，以便能够为您提供相关服务。
          </p>
          <p>
            <strong>数字化运营服务相关功能</strong>
          </p>
          <p>
            <strong>1.资产管理</strong>
          </p>
          <p>
            当您使用“贵州数字乡村平台”服务体系下的资产管理相关的闲置低效资产管理、联络员、部门管理、数据统计分析等服务或功能时，我们需要您提供账号、姓名、联系电话、单位/部门、资产照片、附件材料、定位等相关信息，以便能够为您提供相关服务。
          </p>
          <p>
            <strong>2.乡村百科（黔村百科）</strong>
          </p>
          <p>
            当您使用“贵州数字乡村平台”服务体系下的乡村百科相关的村百科信息采集、审核等服务或功能时，我们需要您提供账号、姓名、联系电话、村委基本信息、村支书信息、民俗文化、村照片、全景应用、定位等相关信息，以便能够为您提供相关服务。
          </p>
          <p>
            <strong>3.随行乡村（贵州）</strong>
          </p>
          <p>
            当您使用“贵州数字乡村平台”服务体系下的随行乡村相关的活动内容管理、精彩瞬间内容、线上报名、上传作品等服务或功能时，我们需要您提供账号、姓名、联系电话、学校名称、个人介绍/照片、作品内容（照片、文件、链接）定位等相关信息，以便能够为您提供相关服务。
          </p>
          <p>
            <strong>4.徒步乡村（贵州）</strong>
          </p>
          <p>
            当您使用“贵州数字乡村平台”服务体系下的徒步乡村相关的活动区域管理、徒步路线管理、报名/导航/打卡等服务或功能时，我们需要您提供账号、姓名、联系电话、地址、定位、等相关信息，以便能够为您提供相关服务。
          </p>
          <p>
            <strong>5.</strong><a name="OLE_LINK3"></a
            ><a name="OLE_LINK4"><strong>最美庭院/村庄清洁行动</strong></a>
          </p>
          <p>
            当您使用“贵州数字乡村平台”服务体系下的最美庭院/村庄清洁行动相关的行动/行动区域管理、先进农户填报/上报、先进村填报/上报、投票等服务或功能时，我们需要您提供账号、姓名、联系电话、活动照片、定位等相关信息，以便能够为您提供相关服务。
          </p>
          <p>
            <strong>(三) 客服、其他用户响应功能</strong>
          </p>
          <p>
            当您与我们的客服互动时或使用其他用户响应功能时（包括：在线提交意见反馈、与在线/人工客服沟通、提出我们的产品与/或服务的售后申请、行使您的相关个人信息控制权、其他客户投诉和需求），为了您的账号与系统安全，我们可能需要您先行提供账号信息，并与您之前的个人信息相匹配以验证您的用户身份。在您使用客服或其他用户响应功能时，我们可能还会需要收集<strong>您的如下个人敏感信息：联系方式（您与我们联系时使用的电话号码/电子邮箱或您向我们主动提供的其他联系方式）、您与我们的沟通信息（包括文字/图片/音视频/通话记录形式）、与您需求相关联的其他必要信息。</strong>我们收集这些信息是为了调查事实与帮助您解决问题，如您拒绝提供可能导致您无法使用我们的客服等用户响应机制。
          </p>
          <p>
            <strong>(四) 产品安全保障功能</strong>
          </p>
          <p>
            我们需要收集您的一些信息来保障您使用我们的产品与/或服务时的账号与系统安全，并协助提升我们的产品与/服务的安全性和可靠性，以防产生任何危害用户、贵州小黑科技有限公司、社会的行为，包括<strong>您的如下个人信息：账号登录地、个人常用设备信息（例如：硬件型号、设备MAC地址、IMEI、IMSI）、登录IP地址、产品版本号、语言模式、浏览记录、网络使用习惯、服务故障信息，以及个人敏感信息：收货地址、个人身份信息。</strong>我们会根据上述信息来综合判断您账号、账户风险、进行身份验证、客户服务、检测及防范安全事件、诈骗监测、存档和备份用途，并依法采取必要的记录、审计、分析、处置措施，一旦我们检测出存在或疑似存在账号安全风险时，我们会使用相关信息进行安全验证与风险排除，确保我们向您提供的产品和服务的安全性，以用来保障您的权益不受侵害。同时，当发生账号或系统安全问题时，我们会收集这些信息来优化我们的产品和服务。
          </p>
          <p>
            此外，为确保您设备操作环境的安全以及提供我们的产品与/或服务所必需，防止恶意程序和反作弊，我们会在您同意本《“贵州数字乡村平台”用户隐私权政策》后获取您设备上已安装或正在运行的必要的<strong>应用/软件列表信息</strong>（包括应用/软件来源、应用/软件总体运行情况、崩溃情况、使用频率等）。请您知悉，单独的应用/软件列表信息无法识别您的特定身份。
          </p>
          <p>
            <strong>您可自主选择提供个人信息的情形包括：</strong>
          </p>
          <p>
            <strong>1.基于设备相册权限的附加业务功能</strong>
          </p>
          <p>
            当您上传/更新账号头像、图文/视频制作与发布、评论、发帖、意见反馈等业务功能时，我们将需要获取您的设备相册权限，并收集您提供的<strong>图片、视频内容信息（个人信息）。</strong>如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。相册权限是您设备上的一项设置，您可以通过设备设置页面进行管理。当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。
          </p>
          <p>
            <strong>2.基于设备相机权限的附加业务功能</strong>
          </p>
          <p>
            当您拍摄功能、上传/更新账号头像、图文发布等业务功能时，我们将需要获取您的设备相机权限，并收集您提供的<strong>图片、视频内容信息（个人信息）。</strong>如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。相机权限是您设备上的一项设置，您可以通过设备设置页面进行管理。当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。
          </p>
          <p>
            <strong>3.基于位置权限的附加业务功能</strong>
          </p>
          <p>
            在我们的特定服务中，我们需要申请获取您的位置权限，并在您授权后收集您的<strong>位置信息，</strong>前述特定服务场景包括：在“垃圾/污水站点、住房、户厕、公厕、传统村落/农户”等数字化治理服务的信息采集时，以及“资产管理、乡村百科、随行乡村、徒步乡村、最美庭院/村庄清洁行动”
            等使用数字化运营服务时。位置权限是您设备上的一项设置，您可以通过设备设置页面进行管理。当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。
          </p>
          <p>
            <strong>4.从外部第三方间接收集的您的个人信息</strong>
          </p>
          <p>
            您知悉并同意，您向外部第三方（贵州小黑科技有限公司旗下公司不在此限）提供的个人信息，或外部第三方收集的您的个人信息，我们无法获取，更不会使用非常规方式（如：恶意干预对方APP数据）擅自以软件程序获得您的个人信息。如果因业务发展的必要而需要从第三方间接收集（如共享等）您的个人信息的，且由我们直接或联合为您提供产品或服务的，我们（或第三方）在收集前会向您明示共享的您个人信息的来源、类型、使用目的、方式和所用于的业务功能、授权同意范围（如果使用方式和范围超出您在第三方原授权范围的，我们会再次征得您的授权同意），
          </p>
          <p>此种场景包括：</p>
          <p>
            4.1.您通过第三方账户直接登录我们的产品与/或服务时，我们从第三方获取的您授权共享的账户信息（包括头像、昵称）；
          </p>
          <p>
            4.2.我们的某些产品/服务由业务合作伙伴提供或者我们与业务合作伙伴共同提供时，为了必要/合理的业务的顺利开展，我们从部分业务合作伙伴处间接收集的您的部分信息、其他方使用我们的产品与/或服务时所提供有关您的信息（包括发布的与您相关的内容，包括评论、动态、图片、照片、视频）；
          </p>
          <p>
            此外，我们会在间接收集您的个人信息前，明确以书面形式（如协议、承诺书）要求该第三方在已经向您告知其共享的信息内容并取得您的明示同意后由我们间接收集您的个人信息，且涉及您的个人敏感信息时，我们要求第三方在提供给我们使用前需经过您的再次确认，并在协议等层面要求第三方对个人信息来源的合法性和合规性作出承诺，如第三方有违反行为的，我们会明确要求对方承担相应法律责任；同时，我们的专业安全团队对个人信息进行安全加固（包括敏感信息报备、敏感信息加密存储、访问权限控制等）。我们会使用不低于我们对直接收集的用户个人信息同等的保护手段与措施对间接收集的个人信息进行保护。
          </p>
          <p>
            <strong>5.其他</strong>
          </p>
          <p>
            如上文所述，<strong
              >如果某一需要收集您的个人信息的功能或产品/服务未能在本《”贵州数字乡村平台”用户隐私权政策》中予以说明的，或者我们超出了与收集您的个人信息时所声称的目的及具有直接或合理关联范围的，我们将在收集和使用您的个人信息前，通过更新本《“贵州数字乡村平台”用户隐私权政策》、页面提示、弹窗、消息通知、网站公告或其他便于您获知的方式另行向您说明，并为您提供自主选择同意的方式，且在征得您明示同意后收集和使用。请您知悉，如信息无法单独或结合其他信息识别或关联到您的个人身份的，其不属于法律意义上您的个人信息；当您的信息可以单独或结合其他信息识别到您的个人身份时、我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，这些信息在结合使用期间，将作为您的个人信息按照本政策处理与保护。</strong
            >
          </p>
          <p>
            <strong>例外情形</strong>
          </p>
          <p>
            另外，您充分理解并同意，我们在以下情况下收集、使用您的个人信息无需您的授权同意：
          </p>
          <div>
            <p>● 与我们履行法律法规规定的义务相关的；</p>
          </div>
          <div>
            <p>● 与国家安全、国防安全直接相关的；</p>
          </div>
          <div>
            <p>● 与公共安全、公共卫生、重大公共利益直接相关的；</p>
          </div>
          <div>
            <p>● 与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
          </div>
          <div>
            <p>
              ●
              出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
            </p>
          </div>
          <div>
            <p>
              ●
              所收集的信息是您自行向社会公开的或者是从合法公开的渠道（如合法的新闻报道、政府信息公开等渠道）中收集到的；
            </p>
          </div>
          <div>
            <p>● 根据与您签订和履行相关协议或其他书面文件所必需的；</p>
          </div>
          <div>
            <p>
              ●
              用于维护我们的产品与/或服务的安全稳定运行所必需的，例如：发现、处置产品与/或服务的故障；
            </p>
          </div>
          <div>
            <p>● 有权机关的要求、法律法规等规定的其他情形。</p>
          </div>
          <p>
            <a name="employ"></a
            ><strong>三、我们如何使用Cookie和同类技术</strong>
          </p>
          <p>
            <strong>（一）关于Cookie和同类技术</strong>
          </p>
          <p>
            Cookie是包含字符串的小文件，在您登入和使用网站或其他网络内容时发送、存放在您的计算机、移动设备或其他装置内（通常经过加密）。Cookie同类技术是可用于与Cookie类似用途的其他技术，例如：Web
            Beacon、Proxy、嵌入式脚本等。
          </p>
          <p>
            目前，我们主要使用Cookie收集您的个人信息。您知悉并同意，随着技术的发展和我们产品和服务的进一步完善，我们也可能会使用Cookie同类技术。
          </p>
          <p>
            <strong>（二）我们如何使用Cookie和同类技术</strong>
          </p>
          <p>
            在您使用我们的产品与/或服务时，我们可能会使用Cookie和同类技术收集您的一些个人信息，<strong>包括：您访问网站的习惯、您的浏览信息、您的登录信息，</strong>Cookie和同类技术收集该类信息是为了您使用我们的产品与/或服务的必要、简化您重复操作的步骤（如注册、登录）、便于您查看使用历史（如房产认证历史）、向您提供更切合您个人需要的服务内容、保护您的信息和账号安全性、改善我们的产品和服务等。我们承诺仅在本《“贵州数字乡村平台”用户隐私权政策》所述目的范围内使用Cookie和同类技术。
          </p>
          <p>
            如果您的浏览器允许，您可以通过您的浏览器的设置以管理、（部分/全部）拒绝Cookie与/或同类技术；或删除已经储存在您的计算机、移动设备或其他装置内的Cookie与/或同类技术，从而实现我们无法全部或部分追踪您的个人信息。您如需详细了解如何更改浏览器设置，请具体查看您使用的浏览器的相关设置页面。<strong
              >您理解并知悉：我们的某些产品/服务只能通过使用Cookie或同类技术才可得到实现，如您拒绝使用或删除的，您可能将无法正常使用我们的相关产品与/或服务或无法通过我们的产品与/或服务获得最佳的服务体验，同时也可能会对您的信息保护和账号安全性造成一定的影响。</strong
            >
          </p>
          <p>
            <a name="share"></a
            ><strong>四、我们如何共享、转让、公开披露您的个人信息</strong>
          </p>
          <p>
            <strong>（一）共享</strong>
          </p>
          <p>
            我们非常重视保护您的个人信息。目前，未经您的授权同意，我们不会与贵州小黑科技有限公司以外的第三方公司、组织和个人共享您的个人信息，除非存在以下一种或多种情形：
          </p>
          <p>
            <strong
              >1.您自行分享或主动提出共享要求或事先已征得您的授权同意而进行的共享：</strong
            >
          </p>
          <p>
            我们会应您的合法合理的共享要求或在事先征得您授权同意后而共享您的信息，您也可主动基于贵州小黑科技有限公司的产品与服务的分享功能与第三人（包括不特定对象）共享您的个人信息或其他信息，但因您的共享行为而导致的信息泄露、被使用等情况，与贵州小黑科技有限公司无关，您需要自行承担相应的法律责任。
          </p>
          <p>
            <strong>2.为实现我们的服务/功能所必需进行的共享：</strong>
          </p>
          <p>
            您知悉并同意，在某些情况下，为向您提供我们的服务或实现我们的产品与/或服务的业务功能或基于合理商业习惯，我们必须共享您的个人信息，才能实现我们的产品与/或服务的核心功能或提供您需要的服务。例如：与第三方共享联合营销活动中的中奖/获胜者等信息，以便其能及时向您发放奖品/礼品等；我们接受尽职调查或审计时等。
          </p>
          <p>
            <strong
              >3.与贵州小黑科技有限公司公司内部的必要、合理共享；包括：</strong
            >
          </p>
          <p>
            您知悉并同意，为便于我们基于贵州小黑科技有限公司统一的账号体系向您提供一致化服务、识别账号异常、保护贵州小黑科技有限公司或用户或公众的人身财产安全免遭侵害以及便于您进行统一管理，您知悉并同意，您的相关个人信息可能会在贵州小黑科技有限公司的产品内部进行必要共享，但请您放心，我们只会在必要和合理范围内共享信息且仅在前述目的范围内进行处理，如果我们需要共享您的个人敏感信息或关联公司需要改变个人信息的使用或处理目的时，我们会将再次征求您的授权同意。
          </p>
          <p>
            <strong>4.与部分业务合作伙伴的必要共享:</strong
            >&#xa0;<br />您理解并同意，为了必要/合理的业务的顺利开展、满足您的要求、履行我们在相关用户协议或本隐私政策中的义务和行使我们的权利或遵守法律规定等目的，我们可能需要向部分业务合作伙伴共享您的部分信息。但我们承诺我们只会共享您的必要个人信息，如果我们共享您的个人敏感信息或改变个人信息的使用及处理目的，我们会将再次征求您的授权同意。
          </p>
          <p>我们的业务合作伙伴包括：</p>
          <p>
            <strong>4.1为我们的产品与/或服务提供功能支持的服务提供商：</strong
            >包括：提供一键登录服务的运营商、第三方配送公司和其他服务提供商，我们共享信息的目的是可以实现我们产品与/或服务的功能，让您可以正常使用；
          </p>
          <p>
            <strong>4.2第三方SDK类服务商：</strong
            >我们产品中可能会包含第三方SDK或其他类似的应用程序，如您在我们平台上使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息（如以嵌入代码、插件等形式）。服务商收集和处理信息等行为遵守其自身的隐私条款，而不适用于本政策，但我们也会努力审查该第三方的业务准入资质并努力要求该服务商的合法合规性与安全性。为了最大程度保障您的信息安全，我们强烈建议您在使用任何第三方SDK类服务前先行查看其隐私条款。为保障您的合法权益，如您发现这等SDK或其他类似的应用程序存在风险时，建议您立即终止相关操作并及时与我们取得联系。
          </p>
          <p>第三方SDK如下：</p>
          <p>
            （1）为了地图导航和其他位置服务相关目的，我们的产品中会嵌入合作方的SDK或其他类似软件安装列表的应用程序，
            例如高德SDK需要您打开设备位置权限，收集设备所在位置相关信息、设备识别号、联网相关信息，用于地图APP的调取使用并且这些信息将在静默/后台状态中收集使用，以便用户不需要手动输入地理坐标即可获取相关的服务，https://lbs.amap.com/api/android-location-sdk/locationsummary/。
          </p>
          <p>
            （2）为了使用微信账号登陆和分享内容，我们使用了微信SDK，其会采集您的设备唯一标识信息。
          </p>
          <p>
            （3）为了使用小米的消息通知能力给小米手机用户推送消息通知，产品集成了小米推送com.xiaomi.mipush。
          </p>
          <p>
            （4）为了实现对产品内容分享到微博，产品集成了新浪微博com.sina.weibo分享能力。
          </p>
          <p>
            （5）为了实现查看产品线上bug，产品集成了腾讯bugly能力com.tencent.bugly。
          </p>
          <p>
            （6）为了实现产品数据埋点能力，产品集成了腾讯移动分析能力com.tencent.stat，收集范围：设备信息（如IMEI/IMSI、SIM卡序列号/MAC地址、android_id、进程信息）；收集目的：为了实现产品数据埋点能力，以达到实时数据统计分析服务，协助产品、运营和市场决策；收集方式：嵌入第三方SDK，SDK收集传输个人信息。合作方隐私政策：https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e。
          </p>
          <p>
            （7）为了实现产品分享到微信的能力，产品集成了腾讯开放平台com.tencent.open。
          </p>
          <p>
            （8）为了实现产品接入视频监控设备并查看直播和回放，产品集成了七牛云平台com.qiniu。
          </p>
          <p>
            （9）其他信息。 例如：“应用安装列表,ANDROID;
            应用内集成的[极光、极光推送]SDK收取MAC地址;
            应用内集成的[极光、极光推送]SDK收取应用安装列表，短信，通讯录”。这些信息将应用于我们在必要的业务节点，向您推送消息通知和提醒。极光的隐私政策：https://www.jiguang.cn/license/privacy
          </p>
          <p>
            （10）极光SDK收集、使用APP最终用户个人信息的类型和目的：根据相关法律法规，极光SDK为实现如下业务功能、需要收集最终用户的“网络信息”和/或“位置信息”时，前提是最终用户需要授权开启“读写SD卡权限”、“网络访问权限”、“设备信息权限”和/或“位置权限”。如果您的终端用户不想被收集上述信息，可以通过关闭“读写SD卡权限”、“网络访问权限”、“设备信息权限”和/或“位置权限”实现。
          </p>
          <p>
            ①极光推送Jpush
            SDK：通过识别设备信息为App赋予推送能力，用于消息推送；地理位置和网络信息用于创建智能标签，实现区域、分群推送功能,需要通过设备信息获取手机唯一标识、位置信息、网络信息用于推送消息，信息将会采用去标识化化方式对个人信息进行脱敏展示。
          </p>
          <p>
            ②极光IM：通过识别设备信息为App赋予即时消息送达能力，用于即时消息；地理位置和网络信息用于创建智能标签，实现区域、分群即时通讯，总体实现为App赋予即时通讯能力，可用于应用程序内聊天,需要通过设备信息获取手机唯一标识，地理信息，网络信息，用户聊天信息，用于推送消息，信息将会采用去标识化化方式对个人信息进行脱敏展示。
          </p>
          <p>
            ③极光统计JAnalytics
            SDK：针对App的各维度的统计功能，需要通过设备信息获取手机唯一标识、地理位置、网络信息、APP应用页面或视图相关信息用于统计分析，信息将会采用去标识化化方式对个人信息进行脱敏展示。
          </p>
          <p>
            ④极光短信JSMS
            SDK：提供营销、验证码等短信的能力,采集方式为调用系统相关接口自动采集/用户主动提供，需要通过设备信息获取手机唯一标识手机号码与短信内容帮助用户获取短信验证码，信息将会采用去标识化化方式对个人信息进行脱敏展示。
          </p>
          <p>
            ⑤极光认证JVerification
            SDK：为App赋予一键登录，号码认证的能力。采集方式为调用系统相关接口自动采集/用户主动提供,需要通过设备信息获取手机唯一标识、地理位置、网络信息、SDK认证相关请求结果、手机号码，用于帮助用户实现一键登陆。信息将会采用去标识化化方式对个人信息进行脱敏展示。
          </p>
          <p>
            ⑥极光魔链JMLink
            SDK：提供短链跳转的能力，提供智能标签，优化魔链拉起应用的成功率,需要通过设备信息获取手机唯一标识，位置信息，网络信息。用于为用户提供链接跳转功能信息将会采用去标识化化方式对个人信息进行脱敏展示。
          </p>
          <p>
            ⑦极光分享JShare
            SDK：为App赋予社会化分享的能力，需要通过设备信息获取手机唯一标识、位置信息、网络信息，用于为用户提供社交平台分享、第三方登录功能。信息将会采用去标识化化方式对个人信息进行脱敏展示。
          </p>
          <p>
            <strong>5.其他情形：</strong>
          </p>
          <p>
            5.1.共享的是去标识化的信息，且接受该信息共享的第三方无法重新识别信息主体身份；
          </p>
          <p>
            5.2.为了保护您、我们的其他用户或员工、贵州小黑科技有限公司或社会公共利益、财产或安全（例如：欺诈或信用风险等）免遭损害而与第三方的共享；
          </p>
          <p>
            5.3.某些情况下，只有共享您的个人信息，才能实现我们的产品与/或服务的核心功能或提供您需要的服务，或处理您与他人的纠纷或争议；
          </p>
          <p>
            5.4.依据您与我们签署的相关协议（例如：在线协议、平台规则等）或法律文件而共享的；
          </p>
          <p>5.5.符合您与其他第三人之间的有关约定的；</p>
          <p>
            5.6.基于合理商业习惯而共享的，例如：与第三方共享联合营销活动中的中奖/获胜者等信息，以便其能及时向您发放奖品/礼品等；我们接受尽调时等；
          </p>
          <p>
            5.7.基于学术研究而使用，例如：以学术研究为目的而与学术机构共享我们使用您的相关信息集合形成的间接用户画像、去标识化或匿名化处理后的分析/统计类信息（未经您的同意，我们不会与其共享可以识别您身份的个人信息）；学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行匿名化处理的；
          </p>
          <p>
            5.8.有权机关的要求、诉讼争议需要、法律法规等规定的其他需要共享的情形。
          </p>
          <p>
            您可以基于贵州小黑科技有限公司的平台与第三人（包括不特定对象）共享您的个人信息或其他信息，但因您的共享行为而导致的信息泄露、被使用等情况，与贵州小黑科技有限公司无关，您需要自行承担相应的法律责任。
          </p>
          <p>
            我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享必要的个人信息。在我们与业务合作伙伴共享信息时，我们会以多种方式保护您的个人信息，包括但不限于：
          </p>
          <p>
            1.如具备上述合理事由且需要您授权同意的，我们会在共享前向您告知共享的信息的目的、信息接收方的类型以及可能产生的后果（如涉及共享、转让您的个人敏感信息的，我们还会向您告知涉及的个人敏感信息类型、信息接收方的身份和数据安全能力）并在取得您授权同意后再共享；
          </p>
          <p>
            2.此外，我们将对个人信息的共享、转让活动事先进行个人信息安全影响评估，并通过输出形式、流转、使用等采取有效的技术保护措施等。请您知悉，即使已经取得您的授权同意，我们也仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并尽量对共享内容中的个人信息进行匿名化处理。您理解并知悉，匿名化处理后的信息无法识别或关联到您，已不属于法律意义上的个人信息，其处理、使用、共享、转让无需征得您的授权同意。
          </p>
          <p>
            <strong>（二）转让</strong>
          </p>
          <p>
            转让是指将个人信息控制权向其他公司、组织或个人转移的过程。原则上我们不会将您的个人信息转让，但以下情况除外：
          </p>
          <p>1.您自行提出要求的；</p>
          <p>2.事先已征得您的明确授权同意；</p>
          <p>
            3.如我们进行兼并、收购、重组、分立、破产、资产转让或类似的交易，而您的个人信息有可能作为此类交易的一部分而被转移，我们会要求新持有人继续遵守和履行该《“贵州数字乡村平台”用户隐私权政策》的全部内容（包括使用目的、使用规则、安全保护措施等），否则我们将要求其重新获取您的明示授权同意；
          </p>
          <p>4.法律法规等规定的其他情形。</p>
          <p>
            如具备上述事由确需转让的，我们会在转让前向您告知转让的信息的目的、类型（如涉及您的个人敏感信息的，我们还会向您告知涉及的敏感信息的内容），并在征得您的授权同意后再转让，但法律法规另有规定的或本政策另有约定的除外。
          </p>
          <p>
            <strong>（三）公开披露</strong>
          </p>
          <p>
            公开披露是指向社会或不特定人群发布信息的行为。除了因需要对违规账号、欺诈行为等进行处罚公告、公布中奖/获胜者等名单时脱敏展示相关信息等必要事宜而进行的必要披露外，我们不会对您的个人信息进行公开披露，如因经法律授权或具备合理事由确需公开披露的，我们会在公开披露前向您告知公开披露的信息的目的、类型（如涉及您的个人敏感信息的，我们还会向您告知涉及的敏感信息的内容），并在征得您的明示同意后再公开披露，但法律法规另有规定的或本政策另有约定的除外。
          </p>
          <p>
            对于公开披露的您的个人信息，我们会充分重视风险，在收到公开披露申请后第一时间且审慎审查其正当性、合理性、合法性，并在公开披露时和公开披露后采取不低于本《“贵州数字乡村平台”用户隐私权政策》约定的个人信息安全保护措施和手段的程度对其进行保护。
          </p>
          <p>
            请您知悉，即使已经取得您的授权同意，我们也仅会出于合法、正当、必要、特定、明确的目的公开披露您的个人信息，并尽量对公开披露内容中的个人信息进行匿名化处理。
          </p>
          <p>
            <strong>（四）委托处理</strong>
          </p>
          <p>
            为了提升信息处理效率，降低信息处理成本或提高信息处理准确性，我们可能会授权有能力的我们的关联公司或其他专业机构代表我们来处理用户信息，以便授权的关联公司或其他专业机构能代表我们为您提供某些服务或履行职能。我们会通过书面协议、现场审计等方式要求受托公司遵守严格的保密义务及采取有效的保密措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息，禁止其将这些信息用于未经用户授权的用途。委托关系解除后，受托公司将不再保存您的个人信息。
          </p>
          <p>
            <strong>例外情形</strong>
          </p>
          <p>
            根据法律法规等规定，在下述情况下，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
          </p>
          <p>1.与我们履行法律法规规定的义务相关的；</p>
          <p>2.与国家安全、国防安全直接相关的；</p>
          <p>3.与公共安全、公共卫生、重大公共利益直接相关的；</p>
          <p>
            4.与犯罪侦查、起诉、审判和判决执行等直接相关的；或根据法律法规的要求、行政机关或公检法等有权机关的要求的；
          </p>
          <p>
            5.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
          </p>
          <p>
            6.个人信息是您自行向社会公开的或者是我们从合法公开披露的渠道（如合法的新闻报道、政府信息公开等渠道）中收集到的；
          </p>
          <p>7.根据与您签订和履行相关协议或其他书面文件所必需的；</p>
          <p>8.法律法规等规定的其他情形。</p>
          <p>
            <strong>（五）共享、转让、公开披露的相关责任</strong>
          </p>
          <p>
            我们将严格按照本隐私政策的约定及相关法律法规的要求执行对个人信息的共享、转让、公开披露的操作，如因我们的过错原因导致您的合法权益遭受损害的，我们愿意就我们的过错在法律规定的范围内向您承担相应的损害赔偿责任。如我们违反了法律法规或与您的约定向第三方共享、转让或公开披露个人信息的，您可以要求我们删除，我们将在收到您的请求后立即停止共享、转让、公开披露的信息，并通知第三方及时删除
          </p>
          <p>
            <a name="control"></a><strong>五、您对个人信息享有的控制权</strong>
          </p>
          <p>
            您对我们产品与/或服务中的您的个人信息享有多种方式的控制权，包括：您可以访问、更正/修改、删除您的个人信息，也可以撤回之前作出的对您个人信息的同意，同时您也可以注销您的“贵州数字乡村平台”服务体系下的相关账号。为便于您行使您的上述控制权<strong
              >如您在操作过程中有疑惑或困难的可以通过文末的方式联系我们来进行控制，我们会及时为您处理。</strong
            >
          </p>
          <p>
            <strong>（一）访问权</strong>
          </p>
          <p>您可以在我们的产品与/或服务中查询或访问您的相关个人信息，包括：</p>
          <p>1.账号信息</p>
          <p>
            您可以通过相关产品页面随时登录您的个人账号，随时查询或访问您的账号中的个人资料信息，包括：账号、姓名、手机号、头像、地址、邮箱等，例如：“手机号”信息在“贵州数字乡村平台”APP中的访问路径为：我的—个人信息—手机；
          </p>
          <p>2.使用信息</p>
          <p>
            您可以通过相关产品页面随时访问您的使用信息，包括：我的村、我的订单、我的意见反馈等，例如：“我的村”信息在“禾力乡村”微信小程序中，访问路径为：村务—我的村；
          </p>
          <p>3.其他信息</p>
          <p>
            如您在此访问过程中遇到操作问题的或如需获取其他前述无法获知的个人信息内容，您可通过文末提供的方式联系我们，我们将在核实您的身份后在合理期限内向您提供，但法律法规另有规定的或本政策另有约定的除外。
          </p>
          <p>
            <strong>（二）更正/修改权</strong>
          </p>
          <p>
            您可以在我们的产品与/或服务中更正/修改您的相关个人信息。为便于您行使您的上述权利，我们为您提供了在线自行更正/修改和向我们提出更正/修改申请两种方式。
          </p>
          <p>
            对于您的部分个人信息，我们在产品的相关功能页面为您提供了操作指引和操作设置，您可以直接进行更正/修改，例如：“密码”信息在“贵州数字乡村建设监测平台”中的更正/修改路径为：设置中心—个人信息——修改密码；
          </p>
          <p>
            对于您在行使上述权利过程中遇到的困难，或其他可能未/无法向您提供在线自行更正/修改权限的，经对您的身份进行验证，且更正不影响信息的客观性和准确性的情况下，您有权对错误或不完整的信息作出更正或修改，或在特定情况下，尤其是数据错误时，通过我们公布的反馈与报错等措施将您的更正/修改申请提交给我们，要求我们更正或修改您的数据，但法律法规另有规定的除外。但出于安全性和身份识别的考虑，您可能无法修改注册时提交的某些初始注册信息。
          </p>
          <p>
            <strong>（三）删除权</strong>
          </p>
          <p>
            一般而言，我们只会在法律法规规定或必需且最短的时间内保存您的个人信息。为便于您行使您的上述删除权，我们为您提供了在线自行删除和向我们提出删除申请两种方式。
          </p>
          <p>
            对于您的部分个人信息，我们在产品的相关功能页面为您提供了操作指引和操作设置，您可以直接进行删除，一旦您删除后，我们即会对此类信息进行删除或匿名化处理，除非法律法规另有规定。
          </p>
          <p>
            在以下情形下，您可以直接向我们提出删除您个人信息的请求，但已做数据匿名化处理或法律法规另有规定的除外：
          </p>
          <p>1.我们违反法律法规规定，收集、使用您的个人信息的；</p>
          <p>2.我们违反了与您的约定，收集、使用您的个人信息的；</p>
          <p>3.法律法规等规定的其他情形。</p>
          <p>
            关于您不再使用我们提供的产品与/或服务且注销“贵州数字乡村平台”APP账号后、以及我们终止部分或全部产品与/或服务后我们对您的个人信息的处理，我们将在本文其他专门章/节中为您详细作出说明。
          </p>
          <p>
            您理解并同意：当您从我们的产品与/或服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。
          </p>
          <p>
            <strong>(四) 个人信息副本获取权</strong>
          </p>
          <p>
            如您需要您的个人信息的副本，您可以通过本《“贵州数字乡村平台”用户隐私权政策》文末提供的方式联系我们，在核实您的身份后，我们将向您提供您在我们的服务中的个人信息副本（包括基本资料、身份信息），但法律法规另有规定的或本政策另有约定的除外。
          </p>
          <p>
            <strong>(五) 撤回同意权</strong>
          </p>
          <p>
            如您想更改相关权限的授权<strong>（例如：位置、通讯录、相机、相册、麦克风、日历）</strong>，您可以通过您的硬件设备进行修改。如您在此过程中遇到操作问题的，可以通过本《“贵州数字乡村平台”用户隐私权政策》文末提供的方式联系我们。
          </p>
          <p>
            <strong>（六）注销权</strong>
          </p>
          <p>
            我们为您提供“贵州数字乡村平台”服务体系账号注销的途径，您可以通过在线申请注销或联系我们的客服或通过其他我们公示的方式申请注销您的账号。<strong
              >在您注销“贵州数字乡村平台”体系账号后，您将无法再以此账号登录和使用贵州小黑科技有限公司旗下的相关产品与服务；该账号在贵州小黑科技有限公司旗下的产品与服务使用期间已产生的但未消耗完毕的权益及未来的预期利益等全部权益将被清除；该账号下的内容、信息、数据、记录等将会被删除或匿名化处理（但法律法规另有规定或监管部门另有要求的除外）；同时，“贵州数字乡村平台”服务体系账号一旦注销完成，将无法恢复。</strong
            >
          </p>
          <p>
            账号注销的处理期限为<strong>15日</strong>，如您在谨慎考虑后仍执意决定注销您的“贵州数字乡村平台”服务体系账号的，您可以在您使用的我们的产品与/或服务的相关功能设置页面或根据操作指引向我们提交注销申请，例如：“贵州数字乡村平台”APP中的注销路径为：我的—个人信息—注销账号。
          </p>
          <p>
            <strong>（七）提前获知产品与/或服务停止运营权</strong>
          </p>
          <p>
            我们将持续为您提供优质服务，若因特殊原因导致我们的部分或全部产品与/或服务被迫停止运营，我们将提前在显著位置或向您发送推送消息或以其他方式通知您，并将停止对您个人信息的收集，同时在超出法律法规规定的必需且最短期限后，我们将会对所持有的您的个人信息进行删除或匿名化处理。
          </p>
          <p>
            <strong>（八）帮助反馈权</strong>
          </p>
          <p>我们为您提供了多种反馈渠道，具体请见本政策“如何联系我们”章节。</p>
          <p>
            <strong>例外情形</strong>
          </p>
          <p>
            请您理解并知悉，根据法律法规等规定，在下述情况下，我们可能不会响应您的关于查询权、更正/修改权、删除权、撤回同意权、注销权、个人信息副本获取权等的请求：
          </p>
          <p>1.与我们履行法律法规规定的义务相关的；</p>
          <p>2.与国家安全、国防安全直接相关的；</p>
          <p>3.与公共安全、公共卫生、重大公共利益直接相关的；</p>
          <p>4.与刑事侦查、起诉、审判和执行判决等直接相关的；</p>
          <p>5.我们有充分证据表明您存在主观恶意或滥用权利的；</p>
          <p>
            6.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
          </p>
          <p>
            7.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
          </p>
          <p>8.涉及商业秘密的；</p>
          <p>9.法律法规等规定的其他情形。</p>
          <p>
            <a name="storage"></a
            ><strong>六、我们如何存储和保护您的个人信息</strong>
          </p>
          <p>
            <strong>（一）个人信息的存储</strong>
          </p>
          <p>
            <strong>1.存储地点</strong>
          </p>
          <p>
            <strong
              >我们依照法律法规的规定，将您的个人信息存储于中华人民共和国境内。目前我们不存在跨境存储您的个人信息或向境外提供个人信息的场景。</strong
            >如需跨境存储或向境外提供个人信息的，我们会单独向您明确告知（包括出境的目的、接收方、使用方式与范围、使用内容、安全保障措施、安全风险等）并再次征得您的授权同意，并严格要求接收方按照本《“贵州数字乡村平台”用户隐私权政策》以及法律法规相关要求来处理您的个人信息。
          </p>
          <p>2.存储期限</p>
          <p>
            我们在为提供我们的产品和服务之目的所必需且最短的期间内保留您的个人信息，例如：当您使用我们的注册登录、意见反馈、参与活动等功能时，我们需要收集您的手机号码，且在您提供后并在您使用该功能期间，我们需要持续为您保留您的手机号码，以向您正常提供该功能、保障您的账号和系统安全。在超出上述存储期限后，我们会对您的个人信息进行删除或匿名化处理。但您行使删除权、注销账号的或法律法规另有规定的除外。
          </p>
          <p>我们判断个人信息的存储期限主要依据以下标准：</p>
          <div>
            <p>● 保证我们为您提供服务的安全和质量；</p>
          </div>
          <div>
            <p>● 您是否同意更长的留存时间；</p>
          </div>
          <div>
            <p>● 是否存在关于保留期限的其他特别约定或法律法规规定。</p>
          </div>
          <p>
            <strong>(二) 个人信息的保护措施</strong>
          </p>
          <p>
            我们一直都极为重视保护用户的个人信息安全，为此我们采用了符合行业标准的安全技术措施及组织和管理措施等保护措施以最大程度降低您的信息被泄露、毁损、误用、非授权访问、非授权披露和更改的风险。包括：
          </p>
          <p>1.数据安全技术措施</p>
          <p>
            1.1.数据安全收集方面，通过个人信息安全影响评估确认数据收集的合法性、正当性和必要性，识别并以清晰、准确的方式告知用户以征得同意，同时对用户的授权同意采集行为进行日志记录；采用敏感识别工具对收集的用户数据进行分类分级，针对不同级别的数据设置不同等级的安全策略；采用技术措施对收集或产生数据的来源方进行身份识别，确保数据来源的准确性和抗抵赖性；
          </p>
          <p>
            1.2.数据安全传输方面，使用安全通道传输个人信息，并通过合适的加密算法进行安全加密、脱敏处理，确保数据传输过程中个人信息的秘密性和完整性；
          </p>
          <p>
            1.3.数据安全存储方面，采用数据分类分级管理制度，针对数据分类分级结果采取不同的信息存储策略；个人敏感信息需加密存储，确保数据安全使用规范能够落实到位；针对存储有个人信息的数据库加强权限控制与安全审计；定期对个人信息进行备份与恢复，确保个人信息在存储使用过程中的完整性；
          </p>
          <p>
            1.4.数据安全处理方面，依照使用场景和安全需求对个人信息进行脱敏处理，例如：在前端显示个人敏感信息之前需在服务端完成脱敏处理；开发、测试环境严禁使用真实用户信息；实施严格的数据权限控制机制，采取多重身份认证、网络/数据隔离等技术措施，确保能够对处理个人信息的行为进行有效监控，避免数据被违规访问和未授权使用；
          </p>
          <p>
            1.5.数据安全销毁方面，根据法律法规要求和业务实际需求设定个人信息存储的最小可用期限，对到期的数据通过安全删除技术进行处理，确保已销毁数据不可恢复，技术手段包括但不限于数据彻底清除方案、磁盘销毁、物理销毁等；
          </p>
          <p>
            1.6.建立完整的审计机制，对数据生命周期的全流程进行监控与审计，防止您的个人信息遭遇未经授权的访问、公开披露、使用、修改、人为或意外的损坏或丢失；
          </p>
          <p>1.7.其他实现数据安全保护的措施。</p>
          <p>2.数据安全组织和管理措施</p>
          <p>
            2.1.成立专门的个人信息保护责任部门，建立相关的内控管理流程，对可能接触到您的信息的工作人员采取最小化权限原则；
          </p>
          <p>
            2.2.建立数据分类分级制度、业务数据安全使用规范、数据合作规范等管理体系，保障您的信息在收集、传输、使用、存储、转移、销毁等环节的处置满足法律法规相关规范和安全要求；
          </p>
          <p>
            2.3.定期组织员工参加安全与隐私保护相关培训并要求完成规定的考核，加强员工对于保护个人信息重要性的认知；
          </p>
          <p>
            2.4.严格执行等级保护各项制度，通过持续迭代优化安全架构、全面提升合规框架下的安全技术支撑能力，我们的互联网业务系统、大数据平台、私有云平台、后台支撑系统等信息系统全部通过国家公安部信息安全等级测评备案，并获得了由公安部颁发的国家《信息安全等级保护管理办法》三级认证”；
          </p>
          <p>
            2.5.信息安全管理能力获得贵州省网络与信息安全测评认证中心的登记测评报告，并已获得信息系统安全等级保护备案证明，证书编号：5201209901720001。
          </p>
          <p>2.6.其他可行的安全组织和管理措施。</p>
          <p>3.合作协议条款保证</p>
          <p>
            3.1.在我们从第三方间接收集您的个人信息前，我们会明确以书面形式（如合作协议、承诺书）要求该第三方在已经取得您明示同意后收集以及处理（如共享等）个人信息，在书面协议层面要求第三方对个人信息来源的合法性和合规性作出承诺，如第三方有违反行为的，我们会明确要求该第三方承担相应法律责任；
          </p>
          <p>3.2.其他合作协议中明确约定的内容。</p>
          <p>4.安全事件处理</p>
          <p>
            4.1.我们建立了合理有效、科学健全的安全应急响应体系，制定了《网络安全事件应急响应预案》、《紧急安全事件响应机制》、《重大事件应急预案》、《数据安全事件管理规范》等多项安全管理制度，明确了网络安全事件的分类分级标准、安全应急响应组织及职责，并根据安全事件的不同类型和级别制定了适当的应急响应预案，明确规范了安全事件的报告流程和应急响应处置流程（包括研判、分析、抑制、根除、恢复、结果公布和经验总结）。同时由专业的安全技术和运营团队负责维护，便于及时有效的响应、处置各类安全漏洞和突发事件，联合相关部门进行安全事件溯源和打击；
          </p>
          <p>
            4.2.如不幸发生个人信息安全事件的，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、电话、短信、推送通知、信件等一种或多种方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况；
          </p>
          <p>
            4.3.请您知悉并理解，互联网并非绝对安全的环境，我们强烈建议您通过安全方式、使用复杂密码、定期修改密码、不将自己的账号密码及相关个人信息披露给他人等方式，协助我们保证您的账号安全。如您发现自己的个人信息泄密，尤其是您的账户或密码发生泄露，请您立即根据本隐私政策文末中提供的联系方式联络我们，以便我们采取相应措施来保护您的信息安全。
          </p>
          <p>
            <a name="renewal"></a><a name="nonage"></a
            ><strong>七、本《“贵州数字乡村平台”用户隐私权政策》的更新</strong>
          </p>
          <p>
            <strong
              >我们鼓励您在每次使用我们的产品或服务时都查阅我们的《“贵州数字乡村平台”用户隐私权政策》。</strong
            >为了给您提供更好的服务，我们会根据产品的更新情况及法律法规的相关要求更新本《“贵州数字乡村平台”用户隐私权政策》的条款，该更新构成本《“贵州数字乡村平台”用户隐私权政策》的一部分。如该更新造成您在本《“贵州数字乡村平台”用户隐私权政策》下权利的实质减少或重大变更，我们将在本政策生效前通过在显著位置提示或向您发送推送消息或以其他方式通知您，若您继续使用我们的服务，即表示您充分阅读、理解并同意受经修订的《“贵州数字乡村平台”用户隐私权政策》的约束。为保障您的合法权益，我们建议您可以定期在我们平台的设置页面中查看本政策。
          </p>
          <p>上述的“重大变更”包括但不限于：</p>
          <p>
            1.我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息的类型、个人信息的使用方式等；
          </p>
          <p>
            2.我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
          </p>
          <p>3.个人信息共享、转让或公开披露的主要对象发生变化；</p>
          <p>4.您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
          <p>
            5.我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
          </p>
          <p>6.个人信息安全影响评估报告表明存在高风险时；</p>
          <p>7.其他重要的或可能严重影响您的个人权益的情况发生时。</p>
          <p><a name="contact"></a><strong>八、如何联系我们</strong></p>
          <p>
            （一）如您对本《“贵州数字乡村平台”用户隐私权政策》的执行或使用我们的服务时遇到的与隐私保护相关的事宜有任何问题（包括问题咨询、投诉等），我们专门为您提供了多种反馈通道，希望为您提供满意的解决方案：
          </p>
          <p>
            1.联系管理员反馈通道：您可在“贵州数字乡村APP”上查看管理员的电话、QQ联系方式来建立联系，查看路径：我的—联系管理员；
          </p>
          <p>2.人工客服通道：您可以拨打0851-84727726与我们联系。</p>
          <p>
            (二)
            我们会在收到您的意见及建议后，并在验证您的用户身份后的15个工作日内或法律法规规定的期限内尽快向您回复，一般情况下，我们不会因此对您收取服务费。但是，在以下情形下，您理解并知悉，我们将无法响应您的请求：
          </p>
          <p>1.与我们履行法律法规规定的义务相关的；</p>
          <p>2.与国家安全、国防安全直接相关的；</p>
          <p>3.与公共安全、公共卫生、重大公共利益直接相关的；</p>
          <p>4.与犯罪侦查、起诉和审判等有关的</p>
          <p>5.有充分证据表明您存在主观恶意或滥用权利的；</p>
          <p>
            6.出于维护您或其他个人的生命、财产等重大权益但又难得到本人授权同意的；
          </p>
          <p>
            7.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
          </p>
          <p>8.涉及商业秘密的；</p>
          <p>9.法律法规等规定的其他情形。</p>
          <p>
            （三）如果您对我们的回复不满意，或我们对您个人信息的处理方式侵害了您的合法权益，且在您向我们反馈后我们仍拒绝改进的，您可以向工商、公安等监管部门进行投诉、举报。
          </p>
          <p><a name="rests"></a><strong>九、其他</strong></p>
          <p>
            <strong
              >(一)本《“贵州数字乡村平台”用户隐私权政策》的解释及争议解决均应适用中华人民共和国大陆地区法律。如就本政策的签订、履行等发生任何争议的，双方应尽量友好协商解决；协商不成时，任何一方均可向被告住所地享有管辖权的人民法院提起诉讼。</strong
            >
          </p>
          <p>
            （二）本《“贵州数字乡村平台”用户隐私权政策》的标题仅为方便及阅读而设，并不影响正文其中任何规定的含义或解释。
          </p>
          <p>贵州小黑科技有限公司</p>
          <p>&#xa0;</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { NavBar } from "vant";
import { isAndroid } from "@/common/util.js";
export default {
  name: "privacyAgreement",
  components: {
    NavBar,
  },
  data() {
    return {
      showNav: true,
    };
  },
  mounted() {},
  created() {
    if (this.isWeiXin() || this.ismimi()) {
      this.showNav = false;
      document.getElementsByClassName("article-title")[0].style.marginTop =
        "5px";
    }
  },
  beforeCreate() {
    document.title = "用户隐私权政策";
  },
  methods: {
    back() {
      if (isAndroid()) {
        jsMessage.finishCurrentPage();
      } else {
        window.history.back(-1);
      }
    },

    isWeiXin() {
      let ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    //
    ismimi() {
      let userAgent = navigator.userAgent;
      // let userAgent = 'Mozilla/5.0 (Linux; Android 9; ELE-AL00 Build/HUAWEIELE-AL00; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/67.0.3396.87 XWEB/1166 MMWEBSDK/191201 Mobile Safari/537.36 MMWEBID/8156 MicroMessenger/7.0.10.1580(0x27000A5D) Process/appbrand3 NetType/WIFI Language/zh_CN ABI/arm64 miniProgram'
      //  console.log(userAgent)
      let isminiapp = userAgent.match(/miniProgram/);
      // console.log(isminiapp)
      return isminiapp;
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped >
html {
  font-size: 41.4px !important;
}
.privacyAgreement {
  ::v-deep .van-nav-bar__arrow {
    font-size: 20px !important;
    // height: 20px;
  }
  .navBar {
    display: flex;
    align-items: left;
    margin-top: 5px;
    font-size: 48px;
    .arrow {
      margin-left: 10px;
      margin-right: 28%;
    }
  }

  .van-icon {
    color: #000000 !important;
  }
  .agreement_content {
    // text-align: center;
    padding: 30px 20px;
    .textContent {
      text-align: center;
    }
    .textIndent {
      text-indent: 2em;
    }
  }
}
</style>
